import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'sgt-unidade-negocio-configuracao-pedido-form',
    templateUrl: './unidade-negocio-configuracao-pedido-form.component.html',
    styleUrls: ['./unidade-negocio-configuracao-pedido-form.component.less']
})
export class UnidadeNegocioConfiguracaoPedidoFormComponent {
    /** Se a unidade de negócio deve habilitar a possibilidade de informar os comprimentos dos itens nos pedidos e cotações */
    @Input() habilitarComprimentosItensPedidos: boolean;
    @Output() habilitarComprimentosItensPedidosChange = new EventEmitter<boolean>();
}


